import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCommissionDebtTerms, COMMISSION_TERMS_UPDATED } from "../../services/supabase/commissionDebtTermsService";

const currency = (amount) => new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS" }).format(Number(amount || 0));
const date = (value) => value ? new Intl.DateTimeFormat("es-AR", { timeZone: "America/Argentina/Buenos_Aires" }).format(new Date(value)) : "";

export default function CommissionDebtNotice({ branchId, enabled, detailed = false }) {
  const [state, setState] = useState(null);
  useEffect(() => {
    let active = true;
    let pending = false;
    setState(null);
    if (!enabled || !branchId) return undefined;
    const refresh = async () => {
      if (pending) return;
      pending = true;
      try {
        const status = await getCommissionDebtTerms(branchId);
        if (active) setState(status);
      } catch { if (active) setState(null); }
      finally { pending = false; }
    };
    void refresh();
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener("focus", refresh);
    window.addEventListener(COMMISSION_TERMS_UPDATED, refresh);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", refresh);
      window.removeEventListener(COMMISSION_TERMS_UPDATED, refresh);
    };
  }, [branchId, enabled]);
  if (!state || state.branchId !== branchId || (!state.warning && !detailed) || state.outstandingAmount <= 0) return null;
  const blocked = state.newOrdersBlocked === true;
  return (
    <section role={blocked ? "alert" : "status"} style={{
      borderLeft: `4px solid ${blocked ? "#b42318" : "#9c6500"}`,
      background: blocked ? "#fff0ee" : "#fff8db", color: "#202a35",
      padding: "14px 18px", marginBottom: 16, overflowWrap: "anywhere",
    }}>
      <strong>{blocked ? "Pedidos nuevos suspendidos por comisiones vencidas" : "Comisiones pendientes de regularizar"}</strong>
      <p style={{ margin: "6px 0" }}>
        {blocked ? `Deuda vencida: ${currency(state.overdueAmount)}. Puedes terminar y cobrar los pedidos en curso.`
          : `Proximo vencimiento: ${date(state.nextDueAt)}. Saldo pendiente: ${currency(state.outstandingAmount)}.`}
      </p>
      <p style={{ margin: "6px 0" }}>El plazo es de dos meses por comision. Los pagos parciales no reinician el vencimiento.</p>
      {detailed ? <p style={{ margin: "6px 0" }}>Para pagar por transferencia, solicita los datos de cobro a MozzoApp e informa la referencia. La regularizacion se acredita cuando backoffice confirma la recepcion.</p>
        : <Link to="/app/pagos" style={{ color: "#174ea6", fontWeight: 700 }}>Ver comisiones pendientes</Link>}
    </section>
  );
}
